import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { BlocklistPage } from '../pages';

export const routes = (
  <Route
    path="/admin/blocklist"
    element={
      <PrivateRoute>
        <BlocklistPage />
      </PrivateRoute>
    }
  />
);
